import {buffers, Channel, eventChannel} from "redux-saga";
import equals from "fast-deep-equal";
import {call, fork, take, takeEvery} from "redux-saga/effects";
import {PlayedMount} from "../state/types";
import {storageSet, storageGet} from "../../../utils/storage";

export type StorageValue = {
    value: any,
    date?: Date
}|null

export const ToStorage = (name: string, value: any, date?: Date) => {
    if (!value) {
        storageSet(name,null);
    } else {
        const save: {
            value: any,
            date?: string
        } = {
            value: value,
        }
        if (date)
            save.date = date.toISOString();
        storageSet(name, JSON.stringify(save))
    }
}

export const FromStorage = (name: string) => {

    const val = InternalFromStorage(storageGet(name));
    if (val)
        return val.value;
    return null;
}

const InternalFromStorage = (data:string|null):StorageValue => {

    if (!data)
        return null;
    try {
        const content = JSON.parse(data)
        if (!content)
            return null
        if (typeof content !== 'object' || !("value" in content))
            return  null;

        const ret:StorageValue = {
            value: content.value,
        }

        if (content.date) {
            try {
                ret.date = new Date(content.date)
                if (ret.date < new Date() || isNaN(ret.date as any))
                {
                    return null;
                }
            }catch (e) {
                return null;
            }
        }
        return ret;
    }
    catch (e) {
        return null;
    }
}

const storageListener = (name: string) => {
    return eventChannel<{ payload: any }>(emitter=> {
        let rawValue = storageGet(name);
        let value = InternalFromStorage(rawValue);
        const listener = () => {
            const newRawValue = storageGet(name);
            if (newRawValue === rawValue)
                return;
            rawValue = newRawValue;
            const newValue = InternalFromStorage(newRawValue);
            let trigger = false;
            if (!equals(value, newValue)) {
                trigger = true;
            }
            value = newValue;
            if (trigger)
                emitter( { payload: value?.value ?? null });
        }
        emitter( { payload: value?.value ?? null });
        window.addEventListener("storage", listener);
        return ()=> {
            window.removeEventListener("storage", listener);
        }
    }, buffers.sliding(3));
}

export function * Storage (name: string, func: (val: any)=>any) {
    let channel: Channel<{ payload: any }> | null = null;
    yield takeEvery<PlayedMount>("PlayerMount", function *(action) {
        if (action.payload === "Mount") {
            if (channel)
                return;
            channel = (yield call(storageListener, name)) as Channel<{ payload: any }>;
            const current = channel;
            yield fork(function* () {
                try {
                    while (true) {
                        let value: { payload: any } = yield take(current);
                        yield call (func, value.payload)
                    }
                } catch (e) {
                } finally {
                }
            })
        } else if (action.payload === "Unmount" && channel) {
            channel.close();
            channel = null;
        }
    })
}